import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import "./globals.css";
import ErrorBoundary from "./components/ErrorBoundary.tsx";

// Initialize Sentry (only if DSN is configured)
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.PROD ? 'production' : 'development',
    release: `obha-frontend@${new Date().toISOString().split('T')[0]}`,
    
    // Performance monitoring
    tracesSampleRate: 0.1, // 10% of transactions
    tracePropagationTargets: ['obha.sa', 'api.obha.sa'],
    
    // Session replay (optional, for debugging UX issues)
    replaysSessionSampleRate: 0.1, // 10% of sessions
    replaysOnErrorSampleRate: 1.0, // 100% of errors
    
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        maskAllInputs: true,
        blockAllMedia: true,
      }),
    ],
    
    // Filter out noisy errors
    ignoreErrors: [
      // Browser extensions
      'top.GLOBALS',
      // Network errors that users can't do anything about
      'NetworkError',
      'Network request failed',
      'Failed to fetch',
      // Random browser-specific errors
      'ResizeObserver loop',
      'Non-Error promise rejection captured',
      // Generic cross-origin / external script errors
      'Script error',
    ],
  });
  
  if (import.meta.env.DEV) console.log('[Sentry] Initialized in', import.meta.env.PROD ? 'production' : 'development', 'mode');
}

// Hide webview landing page once React mounts successfully
const wvLanding = document.getElementById('webview-landing');
if (wvLanding) wvLanding.style.display = 'none';

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
